import React, { useState } from 'react';
import {  Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { useForm } from 'react-hook-form'

import { Form ,Button} from 'react-bootstrap';

import RequestManager from "../../singletons/RequestManager";




export default function AlertDialog(props){
  console.log(props)

  const [displaymesg, setDisplaymesg] = useState();



  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);


  const {register,handleSubmit,errors,setError} = useForm();

  React.useEffect(() => {
  
   
  }, []);
  
 async function onSubmit(values) {
    let requestManager = new RequestManager();
    let params;

 params ={
    input: {
      id: values.orderid,
      thirdpartyDeliverycompany: values.thirdpartyDeliverycompany,
      thirdpartyDeliverydescription: values.thirdpartyDeliverydescription,
      thirdpartyDeliveryurl:values.thirdpartyDeliveryurl
    }
     }

    
console.log(params,"id")
   
    let response =await requestManager.getResponseFromPredefinedQuery(
      "updateOrder",
      params
    );

    console.log(response,"response")

    setDisplaymesg("Succesfully Updated")

      window.location.reload(false);
   
}
 



  
 



  return (
    <div>




      <Button color="success" onClick={toggle}>Edit</Button>
      <Modal isOpen={modal} toggle={toggle} className="">
      {displaymesg &&
     <div className="alert alert-success">
     <strong>{displaymesg}!</strong> 
     </div>
           }
        <ModalHeader toggle={toggle}>Third Party Delivery</ModalHeader>
        <ModalBody>
        <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Control type="text" name="orderid" hidden id="orderid" defaultValue={props.data.node.id}  ref={register} />
  <Form.Group >
    <Form.Label>Company name</Form.Label>
    <Form.Control type="text" name="thirdpartyDeliverycompany" id="thirdpartyDeliverycompany" defaultValue={props.data.node.thirdpartyDeliverycompany}  ref={register} />
  </Form.Group>
  <Form.Group>
    <Form.Label>Description</Form.Label>
    <Form.Control type="text" name="thirdpartyDeliverydescription" id="thirdpartyDeliverydescription" defaultValue={props.data.node.thirdpartyDeliverydescription} ref={register} />
  </Form.Group>

  <Form.Group>
    <Form.Label>URL</Form.Label>
    <Form.Control type="text" name="thirdpartyDeliveryurl" id="thirdpartyDeliveryurl" defaultValue={props.data.node.thirdpartyDeliveryurl}  ref={register} />
  </Form.Group>

  <ModalFooter>
  
          <Button type="submit" style={{background:"green"}} color="primary">Submit</Button>{' '}
          <Button color="secondary"  style={{background:"red"}} onClick={toggle}>Cancel</Button>

        </ModalFooter>
</Form>


       
        </ModalBody>

      </Modal>
    </div>
  );
}








// WEBPACK FOOTER //
// ./src/pages/TrackOrder/AlertDialog.js